import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-logo-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-logo-svg-icon.component.html',
  styleUrl: './ln-logo-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnLogoSvgIconComponent {
  // @Input() class = 'w-24 h-16 md:w-[202px] md:h-[119px]';
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
